import React from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import fabricHero from "./img/nonwoven1.webp";
import { ensureNamespace } from "../../i18n/ensurePageI18n";

const loadI18n = (i18n) => {
  ensureNamespace(i18n, 'fabric', {
    en: {
      sectionTitle: "Nonwoven Fabric",
      sectionSubtitle: "Optical Inspection for Nonwoven Fabric Quality Control",
      title: "NONWOVEN FABRIC",
      heroDesc: "Wintriss optical inspection systems provide a turnkey quality control solution to the non-woven fabric industry. Defect detection and integration with existing industrial automation software can control advanced processes including automatic stop and rewind management.",
      typicalProductsTitle: "Typical Products",
      typicalProductsContent: "Spunlace Nonwovens, Heat-Bonded Nonwoven Fabrics, Pulp Air-laid Nonwovens, Wet Nonwoven, Spunbond Nonwovens, Meltblown Nonwovens, Acupuncture Nonwovens, Stitch Nonwovens.",
      typicalDefectsTitle: "Typical Defects",
      typicalDefectsContent: "Black spots, holes, oil stains, contaminants, hair, and fiber agglomerates."
    },
    zh: {
      sectionTitle: "不織布",
      sectionSubtitle: "不織布品質光學檢測",
      title: "不織布",
      heroDesc: "微覺視光學檢測系統為不織布產業提供一站式品質管制解決方案。透過缺陷檢測並可與既有工業自動化軟體整合，控制包含自動停機與回卷管理等進階流程。",
      typicalProductsTitle: "典型產品",
      typicalProductsContent: "水刺不織布、熱合不織布、漿料氣流成網不織布、濕法不織布、紡粘不織布、熔噴不織布、針刺不織布、縫編不織布。",
      typicalDefectsTitle: "常見缺陷",
      typicalDefectsContent: "黑點、孔洞、油污、異物、毛髮、纖維團聚。"
    }
  });
};

function Fabric() {
  const { t, i18n } = useTranslation();
  loadI18n(i18n);

  return (
    <div>
      <section className="section-fabric relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t("fabric:sectionTitle")}</h1>
          <p className="text-xl">{t("fabric:sectionSubtitle")}</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">{t("fabric:title")}</h2>
          <p className="leading-relaxed text-sm md:text-base">{t("fabric:heroDesc")}</p>
        </div>
        <div className="flex justify-center">
          <img src={fabricHero} alt={t("fabric:title")} className="rounded-lg shadow-lg w-full max-w-md object-cover" loading="lazy" />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-20 grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("fabric:typicalProductsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("fabric:typicalProductsContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("fabric:typicalDefectsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("fabric:typicalDefectsContent")}</p>
        </div>
      </section>
    </div>
  );
}

export default Fabric;